import React from "react";
import PropTypes from "prop-types";

//
import { ProgressBar } from "react-bootstrap";

function ProgressChart({ low, high, close, symbol }) {
  return (
    <div id="progress-chart">
      <ProgressBar now={close} max={high} />

      <div className="d-flex justify-content-between align-items-center my-2">
        <small className="text-dark fw-bolder truncate">{symbol === 'BTC' ? '$' : ''}{low}</small>
        <small className="text-muted text-center">24H Range</small>
        <small className="text-dark fw-bolder text-end truncate">{symbol === 'BTC' ? '$' : ''}{high}</small>
      </div>
    </div>
  );
}

ProgressChart.propTypes = {
  low: PropTypes.number.isRequired,
  high: PropTypes.number.isRequired,
  close: PropTypes.number.isRequired,
  symbol: PropTypes.string.isRequired,
};

export default ProgressChart;
